import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';
import type { ResultOf, VariablesOf } from 'gql.tada';

// Edits a selection of draft invoices that may span families: the description
// (swapped inside the memo and each line that carries it) and/or the due date.
// Amounts and line items are never touched. The backend runs each family on
// its own, so one family's failure lands on that family's result and the
// others still go through; a non-draft row is reported as skipped.
const UpdateSchoolDraftsMutation = graphql.persisted(
  "UpdateSchoolDrafts",
  graphql(`
    mutation UpdateSchoolDrafts($input: UpdateSchoolDraftsInput!) {
      updateSchoolDrafts(input: $input) {
        success
        familyCount
        updatedCount
        families {
          familyEnrollmentId
          familyName
          updatedCount
          message
          rows {
            invoiceId
            action
            message
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export type UpdateSchoolDraftsInput = VariablesOf<typeof UpdateSchoolDraftsMutation>['input'];
export type UpdateSchoolDraftsPayload = NonNullable<
  ResultOf<typeof UpdateSchoolDraftsMutation>['updateSchoolDrafts']
>;
export type UpdateSchoolDraftsFamily = UpdateSchoolDraftsPayload['families'][number];

export { UpdateSchoolDraftsMutation };

export function useUpdateSchoolDrafts() {
  return useMutation(UpdateSchoolDraftsMutation);
}
